<template>
  <div class="box-wrapper">
    <a
      class="box-delete"
      v-on:click="removeMyself"
      v-if="bActive && !disabled"
      :style="{
        top: bTop - 15 + 'px',
        left: bLeft + bWidth - 15 + 'px',
      }"
      v-bind:class="{ enabled: !disabled }"
    >
      <bg-icon name="fdelete"></bg-icon>
    </a>
    <div
      class="label"
      v-if="bLabel"
      :style="{
        top: bTop + 'px',
        left: bLeft + 'px',
        width: bWidth + 'px',
      }"
      @click="selectBox"
    >
      <input
        type="text"
        :placeholder="bLabel"
        :value="bLabel"
        @change="$emit('updated', $event.target.value, bIndex)"
      />
    </div>

    <div
      class="box"
      :style="{
        top: bTop + 'px',
        left: bLeft + 'px',
        width: bWidth + 'px',
        height: bHeight + 'px',
      }"
      v-bind:class="{ active: bActive }"
      @mousedown="selectBox"
    ></div>
  </div>
</template>

<script>
import BgIcon from "@/components/bg-icon";

export default {
  name: "Box",
  props: [
    "b-top",
    "b-left",
    "b-width",
    "b-height",
    "on-select",
    "b-active",
    "b-index",
    "on-delete",
    "b-label",
    "disabled",
  ],
  components: {
    BgIcon,
  },
  data() {
    return {
      boxLabel: "",
    };
  },
  methods: {
    selectBox() {
      if (!this.disabled) {
        this.onSelect(this.bIndex);
      }
    },
    removeMyself() {
      this.onDelete(this.bIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: absolute;
  border: 2px #0931f0 dashed;
  z-index: 99;
}

.box.enabled {
  &:hover,
  &.active {
    background-color: rgba($color: #0931f0, $alpha: 0.5);
  }
}
.box-delete {
  position: absolute;
  z-index: 101;
  cursor: pointer;
}

.box-delete svg {
  background-color: #fefefe;
  border: 1px solid #ebebef;
  padding: 5px;
  border-radius: 100px;
  width: 30px;
  height: 30px;
  &:hover {
    background-color: #ebebef;
  }
}

input {
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11pt;
  color: white;
  font-weight: 600;
  border: none;
  background-color: transparent;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: white;
  }
}

.label {
  position: absolute;
  border-radius: 6px 6px 0 0;
  height: 35px;
  font-size: 14pt;
  color: #fff;
  font-weight: bold;
  background-color: #0931f0;
  z-index: 100;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active {
  border: 2px #0931f0 solid;
}
</style>
